export default __webpack_public_path__ + "static/media/what_we_do_5.b6df88aa.svg";